import { pluralize } from "@common/helpers/string";

export function scheduleConflictSkippedMessage(count: number): string {
    return `${count} ${pluralize("transaction", count)} skipped: both the payment and its invoice or bill have a schedule. Open them one at a time to resolve them.`;
}
